import { CompanyData } from "../../../Company/CompanyData";
import { ContractorGroupData } from "../../../ContractorGroup/ContractorGroupData";
import { PropertyData } from "../../../Property/PropertyData";
import { RoutineData } from "../../../Routines/RoutineData";
import { UserData } from "../../../User/UserData";

export class RoutineDataUtilities {
  /** @deprecated */
  static getAllCompanies(routines: RoutineData[]): CompanyData[] {
    const allCompanies: CompanyData[] = [];
    for (const routine of routines) {
      for (const company of routine.companies) {
        if (!allCompanies.includes(company)) {
          allCompanies.push(company);
        }
      }
    }
    return allCompanies;
  }

  static getAllProperties(routines: RoutineData[]): PropertyData[] {
    const allProperties: PropertyData[] = [];
    for (const routine of routines) {
      for (const property of routine.properties) {
        if (!allProperties.includes(property.data)) {
          allProperties.push(property.data);
        }
      }
    }
    return allProperties;
  }

  /** @deprecated */
  static getAllContractors(routines: RoutineData[]): ContractorGroupData[] {
    const allContractors: ContractorGroupData[] = [];
    for (const routine of routines) {
      for (const contractor of routine.contractorGroups) {
        if (!allContractors.includes(contractor)) {
          allContractors.push(contractor);
        }
      }
    }
    return allContractors;
  }

  static async getUsersThatAreMemberOfAllProperties(properties: PropertyData[]): Promise<UserData[]> {
    const propertiesToLoad = properties.filter((p) => !p.members.loaded);
    await Promise.all(propertiesToLoad.map((p) => p.members.loadWithPromise())).catch((e) => console.error(e));

    const allUsers: UserData[] = [];
    for (const property of properties) {
      for (const member of property.members.documents) {
        if (!allUsers.includes(member.user)) {
          allUsers.push(member.user);
        }
      }
    }

    return allUsers.filter((u) => !properties.some((p) => !p.members.hasData(u.id)));
  }
}
